// extracted by mini-css-extract-plugin
export default {"select":"SelectElement_select__cWl+D"};